export default __webpack_public_path__ + "static/media/dzrewa_dwa.c3cb8ec8.svg";